import React from 'react';
import { IMaskInput } from 'react-imask';

const PRESETS = {
  cpf: '000.000.000-00',
  cnpj: '00.000.000/0000-00',
  rg: /^[0-9.\-]{0,20}$/,
  zip: '00000-000',
  phone: [{ mask: '(00) 0000-0000' }, { mask: '(00) 00000-0000' }]
};

export const InputMasked = ({
  className = '',
  error,
  mask,
  value,
  onChange,
  onBlur,
  placeholder,
  required,
  lazy = true,
  placeholderChar = '_',
  ...props
}) => {
  const resolvedMask = typeof mask === 'string' && PRESETS[mask] ? PRESETS[mask] : mask;

  return (
    <div className="w-full">
      <IMaskInput
        mask={resolvedMask}
        lazy={lazy}
        placeholderChar={placeholderChar}
        value={value || ''}
        onAccept={(val) => onChange && onChange(val)}
        onBlur={onBlur}
        placeholder={placeholder}
        required={required}
        className={`w-full p-2.5 text-sm border rounded-lg focus:ring-1 outline-none transition-all placeholder-gray-300 bg-white disabled:bg-gray-50 \
                ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-200 bg-red-50' : 'border-gray-300 focus:border-brand-blue focus:ring-brand-blue'} ${className}`}
        {...props}
      />
      {error && (
        <p className="text-[9px] text-red-600 font-bold mt-1 uppercase flex items-center gap-1 animate-pulse">
          <i className="fas fa-exclamation-circle"></i> {error}
        </p>
      )}
    </div>
  );
};